/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EventLevelEnum = 'INFO' | 'WARN' | 'ERROR' | 'CRITICAL';

export const EventLevelEnum = {

    INFO: 'INFO' as EventLevelEnum,

    WARN: 'WARN' as EventLevelEnum,

    ERROR: 'ERROR' as EventLevelEnum,

    CRITICAL: 'CRITICAL' as EventLevelEnum
};

